export default {
  Search: {
    keyword: '供应商/品号/采购员/采购单号',
    supplierNo: '供应商',
    itemNo: '品号',
    expectiveDate: '交货日期',
    employeeNo: '采购员',
    purchaseNo: '采购单号',
    siteList: '采购中心'
  },
  Shippinglist: {
    rank: '序号',
    supplierNo: '供应商',
    supplierName: '供应商名称',
    purchaseNo: '采购单号',
    employeeName: '采购员',
    itemNo: '品号',
    itemName: '品名',
    spec: '规格',
    unitName: '单位',
    unDeliverSumQty: '未交数量',
    unCheckQty: '待检量',
    isCheckedQty: '已检未入',
    needQty: '前置期内交货欠料数量',
    unDeliveryQty: '期间未交数量',
    expectiveDate: '最晚到货日期',
    exportName: '送货排程信息表'
  }
}
